module.exports = __webpack_public_path__ + "static/zulip-58ed79767e7c2151bea35b63fa8a16e1.png";